module.exports = __webpack_public_path__ + "assets/img/dealigenseLogoFillOrange.7af3c660.svg";